/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import useSnackbar from 'src/hooks/useCustomSnackbar';
// libraries
import { Box, Typography, Grid, Divider, MenuItem, Button, Tooltip, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { isEmpty } from 'lodash';
import { selectMenuItemStyle } from 'src/styles/DialogueTabs';
// components
import { btnHandler } from 'src/utils/reminderSelectedTimeFunc';
import AssignedToLead from 'src/components/AssignedToLead';
import * as Yup from 'yup';
import { Iconify } from '../../../../components';
import { FormProvider, RHFSelect, RHFTextField } from '../../../../components/hook-form';
import TreatmentEditPopover from '../../../../pages/dashboard/tables/AllLeadTable/TreatmentEditPopover';
import TreatmentFlowComponent from '../../../../components/treatmentComponents/TreatmentFlowComponent';
import RHFToggleGroup from './RHFToggleGroup';
// store
import { useSelector, dispatch } from '../../../../redux/store';
import { addAppointment, UpdateAppointment, updateSteps, saveNewLeadDetail, updateCompleteStatus, savePersonalLeadDetails, updateSendReminderDuringLeadCreate, getBookingSuggestions } from '../../../../redux/slices/lead';
// hooks/validation
import { useAddTreatment, useTreatmentAndAppointment } from '../../../../hooks';
import usePracticeStaff from '../../../../hooks/usePracticeStaff';
import { TreatmentAndAppointmentSchema } from '../../../../validations/validations';
import { localStorageGetItem, localStorageSetItem } from '../../../../utils/storage-available';
// style
import { gridStyle } from '../../../../styles/TreatmentAndAppointmentStyle';
import { primary, grey } from '../../../../theme/palette';
import { STEP_BADGE as SHARED_STEP_BADGE, SECTION_CARD as SHARED_SECTION_CARD, SECTION_HEADER_LABEL, SECTION_ICON_COLOR } from '../../../../styles/stepFormStyles';
import useAttendanceCreateContext from '../../../../components/attendance/useAttendanceCreateContext.ts';
import CreationStagePicker from './CreationStagePicker';
import useAttendanceUiEnabled from '../../../../hooks/useAttendanceUiEnabled';
import { buildCreationCapture, isAdvancedStage } from './creationAttendance';
import { hasPractitionerRole } from '../../../../utils/practiceUserRoles';


const TreatmentAndAppointment = forwardRef(({ isOverview, handleNext, type }, ref) => {
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const { treatmentsListV2 } = useSelector((state) => state.practiceTreatment);
    const { newLeadDetail, tableRowLead } = useSelector((state) => state.lead);
    const createLeadCallId = useSelector((state) => state.createLeadDialog?.call?.id);
    const { practiceUser } = useSelector((state) => state.practiceUser);
    const { appointmentType, appointmentMethod } = useSelector((state) => state.schema);
    const [creationStage, setCreationStage] = useState(newLeadDetail?.attendanceCapture?.targetStatus || 'NEW');
    const [creationDepositPaid, setCreationDepositPaid] = useState(newLeadDetail?.lead_treatment?.is_treatment_fee_pending === false);
    // "Where is this patient up to?" — the two advanced answers reuse the ordinary
    // Team + Appointment form as the consultation they attended (date + dentist)
    // and save through the shared attendance capture (creationAttendance.js).
    // The advanced stages exist only for practices with attendance capture enabled
    // (PracticePreferences.attendance_capture_eligible); elsewhere Create Lead is the
    // ordinary form, exactly as production today.
    const attendanceUiEnabled = useAttendanceUiEnabled(Number(practiceId));
    const advancedCreate = attendanceUiEnabled && ['CreatLead', 'typeCreatLead'].includes(type) && isAdvancedStage(creationStage);
    const attendanceCtx = useAttendanceCreateContext(advancedCreate ? Number(practiceId) : null, advancedCreate ? creationStage : null, newLeadDetail?.attendanceCapture?.operationKey);
    const [noConsultation, setNoConsultation] = useState(newLeadDetail?.attendanceCapture?.values?.kind === 'not_required');
    const [noConsultationReason, setNoConsultationReason] = useState(newLeadDetail?.attendanceCapture?.values?.reason || '');
    const [captureErrors, setCaptureErrors] = useState({});
    const [treatmentData, setTreatment] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const { getTreatment, getAssignUser, getType, handleSuccessMessage } = useTreatmentAndAppointment({ isOverview, type });
    const [assignToState, setAssignToState] = useState(() => {
        const draftPractitioner = newLeadDetail?.attendanceCapture?.values?.practitioner;
        const fromDraft = draftPractitioner ? practiceUser?.results?.find((pu) => String(pu.id) === String(draftPractitioner)) : null;
        if (fromDraft) return [fromDraft];
        return newLeadDetail?.lead_appointment && getAssignUser() || [];
    });
    const [assignToLeadState, setAssignToLeadState] = useState([]);
    const [anchorEditTreatment, setAnchorEditTreatment] = useState(null);
    const [priceAmountError, setPriceAmountError] = useState(false);
    const [teethAmountError, setTeethAmountError] = useState(false);
    let localTreatmentData = {};
    try { localTreatmentData = JSON.parse(localStorageGetItem('localTreatmentData')) || {}; } catch { /* corrupt localStorage */ }

    const { toggle: EditTreatment, onOpen: onEditTreatment, onClose: onCloseEditTreatment } = useAddTreatment();
    const [practSearch, setPractSearch] = useState('');
    const [showAllPract, setShowAllPract] = useState(false);
    const MAX_VISIBLE_PRACTITIONERS = 7;

    // Avatar-based practitioner/assignee lists
    // Avatar-based practitioner/assignee lists (shared hook)
    const { assignableUsers, bookableStaff } = usePracticeStaff();

    const getDate = (date) => {
        const cleaned = typeof date === 'string' ? date.replace('.0Z', '') : date;
        return moment(cleaned, ['DD-MM-YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm:ss', moment.ISO_8601]);
    };

    const [amount, setAmount] = useState(getTreatment('price') || 0.00);

    const [activeTime, setActiveTime] = useState(advancedCreate ? 'no-reminder' : 'custom reminder');
    const [isOpen, setIsOpen] = useState(false);
    const [assignToStateNoBook, setAssignToStateNoBook] = useState([]);
    const { reminderMethod } = useSelector((state) => state.schema);
    const [suggestions, setSuggestions] = useState(null);

    const defaultValues = {
        treatment: getTreatment('treatment'),
        treatmentValue: amount,
        teethAmount: getTreatment('teeth') || null,
        // Advanced stages show the Team + Appointment form (radioButton 'Yes') without the question.
        radioButton: advancedCreate ? 'Yes' : type === 'followUp' ? getType(type) : (getType(type) || 'Yes'),
        appoinmentDate: (() => {
            // Guard against Invalid Date: lead_appointment can be a truthy object with
            // no/malformed datetime (e.g. a NEW lead), which made new Date(getDate(...))
            // an Invalid Date — truthy, so `|| null` never fired — and crashed the MUI
            // date-fns DateTimePicker ("RangeError: Invalid time value") on open.
            const draftLocal = newLeadDetail?.attendanceCapture?.values?.localTime;
            if (advancedCreate && draftLocal) {
                const draftDate = moment(draftLocal, 'YYYY-MM-DDTHH:mm');
                return draftDate.isValid() ? draftDate.toDate() : null;
            }
            // A booking the call review suggested (CU-869fnzwvt): only for the call this form was opened
            // for, and only until there is a real appointment. Staff still confirm the date and time.
            const suggested = !newLeadDetail?.lead_appointment && String(newLeadDetail?.bookingSuggestion?.callId) === String(createLeadCallId)
                ? newLeadDetail?.bookingSuggestion?.datetime : null;
            const apptDatetime = newLeadDetail?.lead_appointment?.datetime || suggested;
            if (!apptDatetime) return null;
            const parsed = getDate(apptDatetime);
            return parsed && parsed.isValid() ? parsed.toDate() : null;
        })(),
        bookedWith: newLeadDetail?.lead_appointment && getAssignUser() || [],
        practiceContactedVia: newLeadDetail && newLeadDetail.lead_appointment && newLeadDetail.lead_appointment.contacted_via || 'PHONE',
        preferredContactMethod: newLeadDetail && newLeadDetail.lead_appointment && newLeadDetail.lead_appointment.method || 'IN_PRACTICE',
        appointmentType: newLeadDetail && newLeadDetail.lead_appointment && newLeadDetail.lead_appointment.type || 'CONSULTATION',
        reminderDateTime: '',
        OtherNotes: '',
        reminder: '',
        assigneesNoBook: []
    };

    useEffect(() => {
        if (defaultValues.treatment) {
            setTreatment(defaultValues.treatment);
        }
    }, [defaultValues.treatment]);

    // Tell the parent wizard up-front to show the Payment/Message steps.
    // In the follow-up flow this component is only ever mounted for the
    // "Booking Details" step (i.e. booking an appointment), so the flow is
    // always 'payment'. Setting it here — while the form is still empty —
    // is critical: it means selecting a date later no longer transitions
    // `attendance` (null -> 'payment'), which used to trigger a step-array
    // rebuild that remounted this form and wiped the user's input.
    useEffect(() => {
        if (!advancedCreate && (type === 'followUp' || defaultValues.radioButton === 'Yes')) {
            dispatch(updateSteps('payment'));
        }
    }, []);

    // useForm captures the resolver once; the latest form mode is read through a ref.
    // "No consultation took place" (Treatment started) needs no date or dentist.
    const schemaRefs = useRef({ assignToState, activeTime, skipVisit: false });
    schemaRefs.current = { assignToState, activeTime, skipVisit: advancedCreate && creationStage === 'TREATMENT_STARTED' && noConsultation };
    const methods = useForm({
        resolver: (values, context, options) => yupResolver(
            schemaRefs.current.skipVisit
                ? Yup.object().shape({ treatment: Yup.string().required('This field is required') })
                : TreatmentAndAppointmentSchema(schemaRefs.current.assignToState, schemaRefs.current.activeTime)
        )(values, context, options),
        mode: 'onSubmit',
        defaultValues,
    });

    const { control, setValue, clearErrors, watch, getValues, formState: { errors }, handleSubmit, trigger } = methods;

    useEffect(() => {
        if (!isEmpty(localTreatmentData)) {
            if (localTreatmentData.treatment) {
                setTreatment(localTreatmentData.treatment);
                setValue('treatment', localTreatmentData.treatment);
                setValue('teethAmount', localTreatmentData.teethAmount);
            }
            if (localTreatmentData.price) {
                setAmount(localTreatmentData.price);
            }
        }
    }, []);

    useEffect(() => {
        if (assignToState?.length > 0) {
            trigger('bookedWith');
        }
    }, [assignToState, trigger]);

    useEffect(() => {

        if (assignToStateNoBook?.length > 0) {
            setValue('assigneesNoBook', assignToStateNoBook)
        }
    }, [assignToStateNoBook]);

    // Fetch booking suggestions when treatment is selected
    useEffect(() => {
        if (treatmentData?.id && practiceId) {
            dispatch(getBookingSuggestions({ practiceId, treatmentId: treatmentData.id }))
                .then(data => data && setSuggestions(data));
        }
    }, [treatmentData?.id, practiceId]);

    const values = watch();

    const practiceUserId = (e) => e ? practiceUser?.results?.filter(el => e?.includes(`${el?.user?.salutation || ''} ${el?.user?.first_name || ''} ${el?.user?.last_name || ''}`))?.map((el) => el?.id) : [];

    React.useEffect(() => {
        let finalArray = [];
        if (assignToLeadState.length > 0) {
            finalArray = assignToLeadState?.map(e => e?.id);
        }
        dispatch(savePersonalLeadDetails({ assignees: finalArray }));
    }, [assignToLeadState])

    const onSubmit = (data, status) => {
        try {
            if (data.radioButton === '') {
                enqueueSnackbar('Please select one of the option for appointment', {
                    variant: 'error',
                    anchorOrigin: { vertical: 'top', horizontal: 'center' }
                });
                return;
            }
            let capture = null;
            if (advancedCreate) {
                const built = buildCreationCapture(attendanceCtx.context, creationStage, {
                    date: getValues('appoinmentDate'),
                    practitionerId: assignToState?.[0]?.id,
                    noConsultation: creationStage === 'TREATMENT_STARTED' && noConsultation,
                    reason: noConsultationReason,
                }, {
                    practiceId,
                    operationKey: attendanceCtx.operationKey,
                    elapsedMs: attendanceCtx.loadedAt ? performance.now() - attendanceCtx.loadedAt : 0,
                });
                if (!built.capture) {
                    setCaptureErrors(built.errors || {});
                    const topLevel = built.errors?.context || built.errors?.kind;
                    if (topLevel) enqueueSnackbar(topLevel, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
                    return;
                }
                setCaptureErrors({});
                capture = built.capture;
            }
            const detail = { attendanceCapture: capture || null };
            if (capture) dispatch(updateSendReminderDuringLeadCreate(false));
            detail.addAppointment = false;
            detail.lead_treatment = {
                treatment: data.treatment,
                custom_price: amount,
                teethAmount: data.teethAmount,
                ...(capture && creationStage === 'TREATMENT_STARTED' ? { is_treatment_fee_pending: !creationDepositPaid } : {}),
            };
            if (!advancedCreate && data.radioButton === 'Yes') {
                detail.addAppointment = true;
                detail.lead_appointment = {
                    datetime: `${moment(getValues('appoinmentDate')).format('DD-MM-YYYY HH:mm:ss')}.0Z`,
                    method: data.preferredContactMethod,
                    contacted_via: data.practiceContactedVia,
                    assignees: assignToState?.map((el) => el?.id),
                    type: data?.appointmentType
                };
                // Dispatch step expansion synchronously before handleNext to prevent
                // the wizard from closing prematurely (race condition with useEffect ordering).
                // Booking an appointment always runs the booked flow (Payment → Messages),
                // for future and past dates. Historical attendance is captured explicitly
                // through the advanced creation fields, before the parent request.
                dispatch(updateSteps('payment'));
            }
            if (!advancedCreate && data.radioButton === 'No') {
                if (activeTime !== '' && activeTime !== 'no-reminder') {
                    const addReminderObj = {
                        is_completed: false,
                        assignees: data?.assigneesNoBook?.map((el) => el?.id),
                        group: 'FOLLOW_UP',
                        note: data.OtherNotes,
                    };
                    if (data?.reminderDateTime) {
                        addReminderObj.datetime = `${moment(data.reminderDateTime).format('DD-MM-YYYY HH:mm:ss')}.0Z`;
                    }
                    if (data?.reminder) {
                        addReminderObj.method = data.reminder?.toUpperCase();
                    }
                    detail.lead_reminder = addReminderObj
                    dispatch(updateSendReminderDuringLeadCreate(true));
                }
            }
            dispatch(saveNewLeadDetail(detail));
            if (status?.toLowerCase?.() === 'finish') {
                // Only mark as complete if no additional wizard steps are pending
                // (booking 'Yes' expands the wizard with Payment, Personal Details, etc.)
                if (!detail.addAppointment) {
                    dispatch(updateCompleteStatus(true));
                }
                handleNext(true);
                return;
            }
            handleNext(true);
        }
        catch (err) {
            console.error("Error while submitting", err);
            enqueueSnackbar('Something went wrong. Please try again.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
        }
    };

    const handleSuccess = (data) => {
        if (data && data.appoiment === 'Yes') {
            if (data.treatmentId) {
                callAppointment(data.treatmentId);
                return;
            }
            if (type !== 'followUp') {
                handleSuccessMessage({ data });
                handleNext(true);
                return;
            }
        }

        handleSuccessMessage({ data });
        handleNext(true);
    };

    const callAppointment = (treatmentId) => {
        const contactedVia = getValues('practiceContactedVia');
        if (treatmentId && type === 'followUp') {
            if (newLeadDetail && newLeadDetail.lead_appointment) {
                if (moment(getDate(newLeadDetail.lead_appointment.datetime)).format('DD-MM-YYYY HH:mm:ss') !== moment(getValues('appoinmentDate')).format('DD-MM-YYYY HH:mm:ss') ||
                    newLeadDetail.lead_appointment.method !== getValues('preferredContactMethod') ||
                    newLeadDetail.lead_appointment.contacted_via !== getValues('practiceContactedVia')) {
                    const updateAppointment = {
                        lead_treatment: treatmentId,
                        datetime: `${moment(getValues('appoinmentDate')).format('DD-MM-YYYY HH:mm:ss')}.0Z`,
                        method: getValues('preferredContactMethod'),
                        contacted_via: contactedVia[0],
                        assignees: practiceUserId(getValues('bookedWith')),
                        type: getValues('appointmentType')
                    };
                    updateAppointment.lead = tableRowLead.lead_id;
                    updateAppointment.id = newLeadDetail.lead_appointment.id;
                    dispatch(UpdateAppointment(updateAppointment, practiceId, handleSuccess));
                }
                else {
                    handleNext(true);
                }
            }
            else {
                const followUpAppointment = {
                    lead_treatment: treatmentId,
                    datetime: `${moment(getValues('appoinmentDate')).format('DD-MM-YYYY HH:mm:ss')}.0Z`,
                    method: getValues('preferredContactMethod'),
                    contacted_via: contactedVia[0],
                    assignees: practiceUserId(getValues('bookedWith')),
                    type: getValues('appointmentType')
                };
                dispatch(addAppointment(followUpAppointment, practiceId, tableRowLead.lead_id, handleSuccess));
            }
        }
        else if (treatmentId) {
            if (newLeadDetail && newLeadDetail.lead_appointment) {
                if (moment(getDate(newLeadDetail.lead_appointment.datetime)).format('DD-MM-YYYY HH:mm:ss') !== moment(getValues('appoinmentDate')).format('DD-MM-YYYY HH:mm:ss') ||
                    !getValues('bookedWith')?.includes(newLeadDetail.lead_appointment.note) ||
                    newLeadDetail.lead_appointment.method !== getValues('preferredContactMethod') ||
                    newLeadDetail.lead_appointment.contacted_via !== getValues('practiceContactedVia')) {
                    const updateAppointment = {
                        lead_treatment: treatmentId,
                        datetime: `${moment(getValues('appoinmentDate')).format('DD-MM-YYYY HH:mm:ss')}.0Z`,
                        method: getValues('preferredContactMethod'),
                        contacted_via: contactedVia[0],
                        assignees: practiceUserId(getValues('bookedWith')),
                        type: getValues('appointmentType')
                    };
                    updateAppointment.lead = newLeadDetail.lead_treatment.lead;
                    updateAppointment.id = newLeadDetail.lead_appointment.id;
                    dispatch(UpdateAppointment(updateAppointment, practiceId, handleSuccess));
                }
                else {
                    handleNext(true);
                }
            }
                else {
                    const appointmentDetail = {
                        lead_treatment: treatmentId,
                        datetime: `${moment(getValues('appoinmentDate')).format('DD-MM-YYYY HH:mm:ss')}.0Z`,
                        method: getValues('preferredContactMethod'),
                        contacted_via: contactedVia[0],
                        assignees: practiceUserId(getValues('bookedWith')),
                        type: getValues('appointmentType')
                    };
                    // Use existing lead id in follow-up flow; otherwise use newly created lead id
                    const leadIdForAppointment = type === 'followUp'
                        ? (tableRowLead?.lead_id ?? newLeadDetail?.personalDetail?.id ?? newLeadDetail?.id)
                        : newLeadDetail?.id;
                    const statusFlag = type === 'followUp' ? 'followUp' : 'CreatLead';
                    dispatch(addAppointment(appointmentDetail, practiceId, leadIdForAppointment, handleSuccess, statusFlag));
                }
        }
    };

    useImperativeHandle(
        ref,
        () => ({
            async submit(status) {
                await handleSubmit((data) => {
                    onSubmit(data, status);
                }, (errors) => {
                    console.error('[TreatmentAndAppointment] handleSubmit validation errors:', errors);
                    formErrorHandler(errors);
                })();
            }
        }),
        [amount, assignToState, advancedCreate, activeTime, handleSubmit, handleNext, creationDepositPaid, creationStage, noConsultation, noConsultationReason, attendanceCtx]
    );


    const updateNewStep = () => {
        // Mirror onSubmit: booking always runs the booked flow regardless of date.
        // A past appointment is auto-attended server-side, so the lead still lands
        // in Consultation Attended without the (here-unusable) attended-outcome step.
        dispatch(updateSteps('payment'));
    };

    useEffect(() => {
        if (newLeadDetail) {
            if (getValues('appoinmentDate') && newLeadDetail.lead_appointment && newLeadDetail.lead_appointment.datetime) {
                updateNewStep();
            }
        }
    }, [newLeadDetail]);

    const handleClickAwayLister = () => onCloseEditTreatment();

    const handleSaveTreatment = (data) => {
        setTreatment(data.selectedTreatment);
        setAmount(data.treatmentPrice);
        setValue('treatment', data.selectedTreatment);
        setValue('teethAmount', data.teethAmount);
        localStorageSetItem('localTreatmentData', JSON.stringify({ treatment: data.selectedTreatment, teethAmount: data.teethAmount, price: data.treatmentPrice }));
        onCloseEditTreatment();
    };

    const handleTreatmentChipClick = (treatment) => {
        const treatmentName = treatment.treatment_item?.name || treatment.name || '';
        setTreatment(treatmentName);
        setAmount(treatment.custom_price || treatment.price || 0);
        setValue('treatment', treatmentName);
        setValue('teethAmount', null);
        localStorageSetItem('localTreatmentData', JSON.stringify({ treatment: treatmentName, teethAmount: null, price: treatment.custom_price || treatment.price || 0 }));
    };

    const handleTreatment = (event) => {
        onEditTreatment();
        setAnchorEditTreatment(event.currentTarget);
    };

    const formErrorHandler = () => {
        if (type !== 'followUp') return;
        enqueueSnackbar('Required field is missing', {
            variant: 'warning',
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
        });
    };

    const handleStageChange = (stage) => {
        setCreationStage(stage);
        setCaptureErrors({});
        setNoConsultation(false);
        if (isAdvancedStage(stage)) {
            // Same Team + Appointment form as a booking, read as the consultation they attended.
            setValue('radioButton', 'Yes');
            setValue('appointmentType', 'CONSULTATION');
            setActiveTime('no-reminder');
            handleSetAssign((assignToState || []).filter(hasPractitionerRole).slice(0, 1));
            dispatch(updateSteps(null));
        } else {
            setValue('radioButton', 'Yes');
            setActiveTime('custom reminder');
            dispatch(updateSteps('payment'));
        }
    };
    // Advanced stages: only dentists can be "seen by"; bookings keep the full bookable list.
    const staffPool = advancedCreate ? bookableStaff.filter(hasPractitionerRole) : bookableStaff;
    const hideVisitFields = advancedCreate && creationStage === 'TREATMENT_STARTED' && noConsultation;
    const getQuickPastChips = () => [
        { label: 'Yesterday 10:00 AM', value: moment().subtract(1, 'day').hours(10).minutes(0).seconds(0).toDate() },
        { label: 'A week ago 10:00 AM', value: moment().subtract(7, 'day').hours(10).minutes(0).seconds(0).toDate() },
        { label: 'A month ago 10:00 AM', value: moment().subtract(1, 'month').hours(10).minutes(0).seconds(0).toDate() },
    ];

    const handleSetAssign = (values) => {
        setAssignToState(values);
        setValue('bookedWith', values);
    };

    const amountHandleChange = (value) => {
        setAmount(value);
        localStorageSetItem('localTreatmentData', JSON.stringify({ treatment: treatmentData, teethAmount: values.teethAmount, price: value }));
        if (value > 0) {
            setPriceAmountError(false);
            document.body.classList.remove('points-event');
            return;
        }
        setPriceAmountError(true);
    };

    const handleChangeTeeth = (e) => {
        const value = e.target.value > 0 ? e.target.value : '';
        setValue('teethAmount', value);
        localStorageSetItem('localTreatmentData', JSON.stringify({ treatment: treatmentData, teethAmount: value, price: amount }));
        setTeethAmountError(value === 0);
    };

    const handleChangeDate = ({ newValue, field }) => {
        field.onChange(newValue);
        updateNewStep();
    };

    const handleButtonClick = (value) => {
        btnHandler({ value, setValue, btnValues, reminderMethod });
        setActiveTime(value);
    };
    const btnValues = (reminder, reminderDateTime) => {
        setValue('reminder', reminder);
        setValue('reminderDateTime', reminderDateTime);
        clearErrors('reminder');
        clearErrors('reminderDateTime');
    };

    const handleToggleOpen = () => {
        setIsOpen(!isOpen);
    };

    const getQuickBookChips = () => {
        const chips = [];
        const now = moment();
        const popularTimes = suggestions?.popular_times || ['09:00', '14:00', '10:00'];

        // Tomorrow at popular times
        popularTimes.forEach(time => {
            const [hour, minute] = time.split(':');
            const dt = moment().add(1, 'day').hours(parseInt(hour, 10)).minutes(parseInt(minute || 0, 10)).seconds(0);
            chips.push({
                label: `Tomorrow ${dt.format('h:mm A')}`,
                value: dt.toDate(),
            });
        });

        // Next Monday at first popular time
        const daysUntilMon = (8 - now.day()) % 7 || 7;
        const [h] = (popularTimes[0] || '10:00').split(':');
        const nextMon = moment().add(daysUntilMon, 'days').hours(parseInt(h, 10)).minutes(0).seconds(0);
        chips.push({
            label: `Next Mon ${nextMon.format('h:mm A')}`,
            value: nextMon.toDate(),
        });

        return chips.slice(0, 4);
    };

    const starredTreatments = treatmentsListV2?.results?.filter(t => t.is_starred)?.slice(0, 5) || [];

    const STEP_BADGE = SHARED_STEP_BADGE;
    const SECTION_CARD = SHARED_SECTION_CARD;
    const SECTION_HEADER = (icon, label, step) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.25 }}>
            <Box sx={STEP_BADGE}>{step}</Box>
            <Iconify icon={icon} width={16} sx={{ color: SECTION_ICON_COLOR }} />
            <Typography sx={SECTION_HEADER_LABEL}>{label}</Typography>
        </Box>
    );

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ px: 3, py: 2 }}>
                {/* 🦷 TREATMENT SECTION */}
                <Box sx={{ mb: 2.5 }}>
                    {SECTION_HEADER('mdi:tooth-outline', 'Treatment', '1')}
                <Grid container spacing={1} sx={gridStyle(type)} >
                    {EditTreatment && (
                        <TreatmentEditPopover
                            treatment={treatmentData || ''}
                            leadTreatmentSpecification={{ teeth_count: values.teethAmount }}
                            open={EditTreatment}
                            anchorEl={anchorEditTreatment}
                            handleClickAwayLister={handleClickAwayLister}
                            treatmentPrice={amount}
                            handleSaveTreatment={handleSaveTreatment}
                            isFlow
                            disablePortal
                        />
                    )}
                    <TreatmentFlowComponent treatmentData={treatmentData} teethAmount={values.teethAmount} handleTreatment={handleTreatment} amount={amount} errorMessage={errors.treatment?.message} amountError={priceAmountError} amountHandleChange={amountHandleChange} handleChangeTeeth={handleChangeTeeth} teethAmountError={teethAmountError} starredTreatments={starredTreatments} onTreatmentChipClick={handleTreatmentChipClick} />
                </Grid>
                </Box>
                {attendanceUiEnabled && ['CreatLead', 'typeCreatLead'].includes(type) && (
                    <CreationStagePicker value={creationStage} onChange={handleStageChange} />
                )}
                {!advancedCreate && (type === 'followUp' ? null : (
                    <Box sx={{ mb: 2.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
                            <Iconify icon="eva:checkmark-circle-2-fill" width={16} sx={{ color: '#919EAB' }} />
                            <Typography sx={{ fontSize: '10px', color: '#919EAB', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>Book an appointment</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 0.75 }}>
                            {['Yes', 'No'].map((opt) => (
                                <Box key={opt} onClick={() => {
                                    setValue('radioButton', opt);
                                    // Booking always runs the booked flow (Payment → Messages),
                                    // regardless of date — past appointments are auto-ATTENDED server-side.
                                    if (opt === 'Yes') { dispatch(updateSteps('payment')); }
                                    if (opt === 'No') { dispatch(updateSteps(null)); }
                                }}
                                    sx={{
                                        display: 'inline-flex', alignItems: 'center', px: 1.5, py: 0.5,
                                        borderRadius: '10px', fontSize: '13px', fontWeight: 600, cursor: 'pointer',
                                        border: '1px solid', transition: 'all 150ms ease', userSelect: 'none',
                                        ...(values.radioButton === opt
                                            ? { borderColor: '#00AB55', color: '#00AB55', background: 'rgba(0,171,85,0.06)' }
                                            : { borderColor: 'rgba(145,158,171,0.24)', color: '#637381', background: 'transparent', '&:hover': { borderColor: '#919EAB', background: '#fafafa' } }),
                                    }}>
                                    {opt}
                                </Box>
                            ))}
                        </Box>
                    </Box>
                ))}
                <Box sx={{ mt: '0' }}>
                    {values.radioButton === 'Yes' ?
                        <>
                            {type === 'followUp' ? null :
                                <Divider sx={{ mb: 2 }} />
                            }

                            {/* ── 👥 TEAM SECTION ── */}
                            <Box sx={{ mb: 2.5, mt: 2 }}>
                                {SECTION_HEADER('eva:people-fill', 'Team', '2')}
                                <Box sx={{ ...SECTION_CARD, display: 'flex', gap: 4 }}>
                                    <Box>
                                        <Typography sx={{ fontSize: '10px', color: '#919EAB', textTransform: 'uppercase', letterSpacing: '0.3px', fontWeight: 600, mb: 0.75 }}>
                                            {advancedCreate ? 'Seen by (dentist)' : 'Booked with'} <span style={{ color: '#FF5630' }}>*</span>
                                        </Typography>
                                        {staffPool.length > 7 && showAllPract && (
                                            <Box sx={{ mb: 0.75 }}>
                                                <input type="text" value={practSearch} onChange={(e) => setPractSearch(e.target.value)} placeholder="Search practitioners…"
                                                    style={{ border: '1px solid rgba(145,158,171,0.16)', borderRadius: '10px', padding: '4px 10px', fontSize: '12px', width: '200px', outline: 'none' }} />
                                            </Box>
                                        )}
                                        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                            {(() => {
                                                const q = practSearch.toLowerCase();
                                                const filtered = q ? staffPool.filter(u => u._name.toLowerCase().includes(q)) : staffPool;
                                                const visible = showAllPract ? filtered : filtered.slice(0, MAX_VISIBLE_PRACTITIONERS);
                                                const overflow = filtered.length - MAX_VISIBLE_PRACTITIONERS;
                                                return (<>
                                                    {visible.map((u) => {
                                                        const isSelected = assignToState?.some(a => a.id === u.id || (typeof a === 'string' && a.includes(u?.user?.first_name)));
                                                        const isPract = hasPractitionerRole(u);
                                                        return (
                                                            <Tooltip key={u.id} title={u._name} arrow placement="top"
                                                                componentsProps={{ tooltip: { sx: { bgcolor: '#078DEE', fontSize: '11px', fontWeight: 600 } }, arrow: { sx: { color: '#078DEE' } } }}>
                                                                <Box data-testid={`staff-chip-${u.id}`} onClick={() => { if (isSelected) handleSetAssign(assignToState.filter(a => a.id !== u.id)); else handleSetAssign(advancedCreate ? [u] : [...(assignToState || []), u]); }}
                                                                    sx={{ width: 30, height: 30, borderRadius: '50%', position: 'relative', cursor: 'pointer', border: '2px solid', borderColor: isSelected ? '#00AB55' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', background: isSelected ? 'rgba(0,171,85,0.06)' : (isPract ? 'rgba(7,141,238,0.08)' : 'rgba(133,92,248,0.08)'), fontSize: '11px', fontWeight: 600, color: isSelected ? '#00AB55' : (isPract ? '#078DEE' : '#855CF8'), transition: 'all 150ms ease', '&:hover': { borderColor: isPract ? '#078DEE' : '#855CF8' } }}>
                                                                    {u.user?.avatar ? <img src={u.user.avatar} alt="" style={{ width: 26, height: 26, borderRadius: '50%', objectFit: 'cover' }} /> : u._initials}
                                                                    {isSelected && <Box sx={{ position: 'absolute', bottom: -2, right: -2, width: 12, height: 12, borderRadius: '50%', background: '#00AB55', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1.5px solid #fff' }}><Iconify icon="eva:checkmark-fill" width={8} sx={{ color: '#fff' }} /></Box>}
                                                                </Box>
                                                            </Tooltip>
                                                        );
                                                    })}
                                                    {!showAllPract && overflow > 0 && !q && (
                                                        <Tooltip title={`Show ${overflow} more`} arrow placement="top">
                                                            <Box onClick={() => setShowAllPract(true)}
                                                                sx={{ width: 30, height: 30, borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1.5px dashed', borderColor: '#C4CDD5', color: '#919EAB', fontSize: '10px', fontWeight: 700, transition: 'all 150ms ease', '&:hover': { borderColor: '#078DEE', color: '#078DEE' } }}>
                                                                +{overflow}
                                                            </Box>
                                                        </Tooltip>
                                                    )}
                                                </>);
                                            })()}
                                        </Box>
                                        {errors?.bookedWith && <Typography sx={{ fontSize: '11px', color: '#FF5630', mt: 0.5 }}>{errors.bookedWith.message}</Typography>}
                                        {captureErrors.practitioner && <Typography role="alert" sx={{ fontSize: '11px', color: '#FF5630', mt: 0.5 }}>{captureErrors.practitioner}</Typography>}
                                        {advancedCreate && !staffPool.length && <Typography sx={{ fontSize: '11px', color: '#FF5630', mt: 0.5 }}>No dentists are set up for this practice.</Typography>}
                                    </Box>
                                    {assignableUsers.length > 0 && (
                                    <Box>
                                        <Typography sx={{ fontSize: '10px', color: '#919EAB', textTransform: 'uppercase', letterSpacing: '0.3px', fontWeight: 600, mb: 0.75 }}>Assigned to</Typography>
                                        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                            {assignableUsers.map((u) => {
                                                const isSelected = assignToLeadState?.some(a => a.id === u.id);
                                                return (
                                                    <Tooltip key={u.id} title={u._name} arrow placement="top"
                                                        componentsProps={{ tooltip: { sx: { bgcolor: '#855CF8', fontSize: '11px', fontWeight: 600 } }, arrow: { sx: { color: '#855CF8' } } }}>
                                                        <Box onClick={() => { if (isSelected) setAssignToLeadState(assignToLeadState.filter(a => a.id !== u.id)); else setAssignToLeadState([...(assignToLeadState || []), u]); }}
                                                            sx={{ width: 30, height: 30, borderRadius: '50%', overflow: 'hidden', cursor: 'pointer', border: '2px solid', borderColor: isSelected ? '#00AB55' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', background: isSelected ? 'rgba(0,171,85,0.06)' : 'rgba(133,92,248,0.08)', fontSize: '11px', fontWeight: 600, color: isSelected ? '#00AB55' : '#855CF8', transition: 'all 150ms ease', '&:hover': { borderColor: '#855CF8' } }}>
                                                            {u.user?.avatar ? <img src={u.user.avatar} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : u._initials}
                                                        </Box>
                                                    </Tooltip>
                                                );
                                            })}
                                        </Box>
                                    </Box>
                                    )}
                                </Box>
                            </Box>

                            {/* ── 📅 APPOINTMENT SECTION ── */}
                            <Box sx={{ mb: 2.5 }}>
                                {SECTION_HEADER('eva:calendar-fill', advancedCreate ? 'Consultation they attended' : 'Appointment', '3')}
                                <Box sx={SECTION_CARD}>

                                {/* Date picker */}
                                <Box sx={{ mb: 1.5, display: hideVisitFields ? 'none' : 'block' }}>
                                    <Controller
                                        name='appoinmentDate'
                                        control={control}
                                        render={({ field, fieldState: { error } }) => (
                                            <DateTimePicker
                                                {...field}
                                                label={advancedCreate ? 'Date and time of the consultation (Required)' : 'Appointment date (Required)'}
                                                maxDateTime={advancedCreate ? new Date() : undefined}
                                                value={field.value || null}
                                                format='dd/MM/yyyy HH:mm'
                                                onChange={(newValue) => handleChangeDate({ newValue, field })}
                                                ampm={false}
                                                slotProps={{ textField: { fullWidth: true, size: 'small', error: !!error || Boolean(captureErrors.localTime || captureErrors.offset || captureErrors.appointment), helperText: error?.message || captureErrors.localTime || captureErrors.offset || captureErrors.appointment, onKeyDown: (e) => e.preventDefault(), sx: { '& .MuiOutlinedInput-root': { borderRadius: '10px' } } } }}
                                            />
                                        )}
                                    />
                                </Box>

                                {/* Quick presets */}
                                <Box sx={{ display: hideVisitFields ? 'none' : 'flex', flexWrap: 'wrap', gap: 0.75, mb: 2 }}>
                                    {(advancedCreate ? getQuickPastChips() : getQuickBookChips()).map((chip, idx) => (
                                        <Box key={idx} onClick={() => setValue('appoinmentDate', chip.value, { shouldValidate: true, shouldDirty: true })}
                                            sx={{ display: 'inline-flex', alignItems: 'center', px: 1.25, py: 0.5, borderRadius: '10px', fontSize: '12px', fontWeight: 600, cursor: 'pointer', background: '#f4f6f8', color: '#637381', transition: 'all 150ms ease', '&:hover': { background: 'rgba(0,171,85,0.06)', color: '#00AB55' } }}>
                                            <Iconify icon='mdi:clock-outline' width={14} sx={{ mr: 0.5, color: '#919EAB' }} />
                                            {chip.label}
                                        </Box>
                                    ))}
                                </Box>

                                {/* Method / Type / Contact */}
                                <Box sx={{ display: hideVisitFields ? 'none' : 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, columnGap: 2, rowGap: 2 }}>
                                    <RHFToggleGroup control={control} label='Method' name='preferredContactMethod' options={appointmentMethod} />
                                    {advancedCreate ? (
                                        <Box>
                                            <Typography sx={{ fontSize: '10px', color: '#919EAB', textTransform: 'uppercase', letterSpacing: '0.3px', fontWeight: 600, mb: 0.75 }}>Type</Typography>
                                            <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#212B36' }}>Consultation <Typography component="span" sx={{ fontSize: '11px', color: '#919EAB', fontWeight: 400 }}>fixed for this choice</Typography></Typography>
                                        </Box>
                                    ) : (
                                        <RHFToggleGroup control={control} label='Type' name='appointmentType' options={appointmentType} />
                                    )}
                                    <RHFToggleGroup control={control} label='Contact' name='practiceContactedVia' options={[
                                        { value: 'EMAIL', label: 'Email' },
                                        { value: 'PHONE', label: 'Phone' },
                                        { value: 'WHATSAPP', label: 'WhatsApp' },
                                    ]} />
                                </Box>
                                {advancedCreate && creationStage === 'TREATMENT_STARTED' && (
                                    <Box sx={{ mt: 2, pt: 1.5, borderTop: '1px dashed rgba(145,158,171,0.32)', display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                        <FormControlLabel control={<Checkbox checked={noConsultation} onChange={(e) => { setNoConsultation(e.target.checked); setCaptureErrors({}); }} />}
                                            label="No consultation took place — treatment started directly" />
                                        {noConsultation && (
                                            <TextField size="small" label="Why was there no consultation?" value={noConsultationReason} onChange={(e) => setNoConsultationReason(e.target.value)}
                                                error={Boolean(captureErrors.reason)} helperText={captureErrors.reason} inputProps={{ maxLength: 2000 }} sx={{ maxWidth: 480, mb: 1 }} />
                                        )}
                                        <FormControlLabel control={<Checkbox checked={creationDepositPaid} onChange={(e) => setCreationDepositPaid(e.target.checked)} />} label="Deposit already paid" />
                                    </Box>
                                )}
                                {advancedCreate && (
                                    <Typography sx={{ fontSize: '12px', color: '#637381', mt: 1.5, lineHeight: 1.5, textTransform: 'none' }}>
                                        {creationStage === 'CONSULTATION_ATTENDED'
                                            ? 'Saved as one consultation, attended on this date by this dentist. The patient goes to Consultation Attended and the report counts them on this date.'
                                            : 'Saved as an attended consultation (unless none took place), then treatment is started today. Treatment Started counts from today; Consultation Attended counts from the consultation date.'}
                                    </Typography>
                                )}
                                </Box>
                            </Box>

                            {/* Suggestions (preserved from original) */}
                            <Box>
                                    {(suggestions?.suggested_practitioner || suggestions?.frequently_used_assignees?.length > 0) && (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75, mt: 1.5 }}>
                                            {suggestions?.suggested_practitioner && (
                                                <Button
                                                    variant='outlined'
                                                    size='small'
                                                    onClick={() => {
                                                        const matchedPU = practiceUser?.results?.find(pu => pu.id === suggestions.suggested_practitioner.id);
                                                        if (matchedPU) handleSetAssign([matchedPU]);
                                                    }}
                                                    startIcon={<Iconify icon='mdi:account-check-outline' width={16} height={16} sx={{ color: primary.main }} />}
                                                    sx={{
                                                        borderRadius: '50px',
                                                        border: '1px solid rgba(0, 167, 111, 0.48)',
                                                        p: '4px 12px 4px 8px',
                                                        height: '32px',
                                                        color: grey[800],
                                                        bgcolor: 'transparent',
                                                        fontWeight: 400,
                                                        textTransform: 'none',
                                                        fontSize: '0.8125rem',
                                                        minWidth: 'auto',
                                                        '&:hover': {
                                                            bgcolor: 'rgba(0, 167, 111, 0.08)',
                                                            borderColor: primary.main,
                                                        },
                                                    }}
                                                >
                                                    {`${suggestions.suggested_practitioner.first_name} ${suggestions.suggested_practitioner.last_name} (${suggestions.suggested_practitioner.booking_count} bookings)`}
                                                </Button>
                                            )}
                                            {suggestions?.frequently_used_assignees?.slice(0, 3).map(a => {
                                                const matchedPU = practiceUser?.results?.find(pu => pu.id === a.id);
                                                const isSelected = assignToLeadState?.some(s => s?.id === a.id);
                                                return (
                                                    <Button
                                                        key={a.id}
                                                        variant='outlined'
                                                        size='small'
                                                        onClick={() => matchedPU && setAssignToLeadState([matchedPU])}
                                                        startIcon={
                                                            <Iconify
                                                                icon={isSelected ? 'bi:check-circle-fill' : 'mdi:account-outline'}
                                                                width={16}
                                                                height={16}
                                                                sx={{ color: isSelected ? primary.main : grey[400] }}
                                                            />
                                                        }
                                                        sx={{
                                                            borderRadius: '50px',
                                                            border: `1px solid ${isSelected ? primary.main : 'rgba(145, 158, 171, 0.32)'}`,
                                                            p: '4px 12px 4px 8px',
                                                            height: '32px',
                                                            color: isSelected ? primary.main : grey[800],
                                                            bgcolor: 'transparent',
                                                            fontWeight: 400,
                                                            textTransform: 'none',
                                                            fontSize: '0.8125rem',
                                                            minWidth: 'auto',
                                                            '&:hover': {
                                                                bgcolor: 'rgba(145, 158, 171, 0.08)',
                                                                borderColor: isSelected ? primary.main : 'rgba(145, 158, 171, 0.48)',
                                                            },
                                                        }}
                                                    >
                                                        {`${a.first_name} ${a.last_name}`.trim()}
                                                    </Button>
                                                );
                                            })}
                                        </Box>
                                    )}
                                </Box>
                        </>
                        : values.radioButton === 'No' ? (
                            <>
                                {/* ── 🔔 FOLLOW UP REMINDER ── */}
                                <Box sx={{ mt: 2, mb: 2.5 }}>
                                    {SECTION_HEADER('eva:bell-fill', 'Follow up reminder', '2')}
                                    <Box sx={SECTION_CARD}>
                                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mb: 1.5 }}>
                                        {[
                                            { key: '2 hours-call', label: '2 hours' },
                                            { key: 'tomorrow', label: 'Tomorrow 9am' },
                                            { key: 'week', label: '1 week' },
                                            { key: 'two-week', label: '2 weeks' },
                                            { key: 'custom reminder', label: 'Custom' },
                                            { key: 'no-reminder', label: 'No reminder' },
                                        ].map((preset) => (
                                            <Box key={preset.key} onClick={() => handleButtonClick(preset.key)}
                                                sx={{
                                                    display: 'inline-flex', alignItems: 'center', px: 1.25, py: 0.5,
                                                    borderRadius: '10px', fontSize: '12px', fontWeight: 600, cursor: 'pointer',
                                                    border: '1px solid', transition: 'all 150ms ease', userSelect: 'none', whiteSpace: 'nowrap',
                                                    ...(activeTime === preset.key
                                                        ? (preset.key === 'no-reminder'
                                                            ? { borderColor: '#637381', color: '#fff', background: '#637381', boxShadow: '0 2px 8px rgba(99,115,129,0.24)' }
                                                            : { borderColor: '#00AB55', color: '#00AB55', background: 'rgba(0,171,85,0.06)' })
                                                        : { borderColor: 'rgba(145,158,171,0.24)', color: '#637381', background: 'transparent', '&:hover': { borderColor: '#919EAB', background: '#fafafa' } }),
                                                }}>
                                                {preset.label}
                                            </Box>
                                        ))}
                                    </Box>

                                    {/* Custom date + reminder method */}
                                    {activeTime === 'custom reminder' && (
                                        <Box sx={{ display: 'flex', gap: 2, mb: 2, maxWidth: 500 }}>
                                            <Box sx={{ flex: 1 }}>
                                                <Controller
                                                    name='reminderDateTime'
                                                    control={control}
                                                    render={({ field, fieldState: { error } }) => (
                                                        <DateTimePicker
                                                            open={isOpen}
                                                            onOpen={handleToggleOpen}
                                                            onClose={() => setIsOpen(false)}
                                                            label='Date & time'
                                                            value={field.value || null}
                                                            format='dd/MM/yyyy HH:mm'
                                                            ampm={false}
                                                            minDateTime={new Date()}
                                                            onChange={(newValue) => field.onChange(newValue)}
                                                            slotProps={{
                                                                textField: {
                                                                    fullWidth: true, size: 'small',
                                                                    error: !!error, helperText: error?.message,
                                                                    onKeyDown: (e) => e.preventDefault(),
                                                                    sx: { '& .MuiOutlinedInput-root': { borderRadius: '10px' } }
                                                                },
                                                                toolbarButton: { onClick: handleToggleOpen }
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Box>
                                            <Box sx={{ flex: 1 }}>
                                                <RHFSelect
                                                    name='reminder'
                                                    label='Method'
                                                    SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
                                                    size='small'
                                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                                                >
                                                    {reminderMethod?.map((options) => (
                                                        <MenuItem key={options.label} value={options.value} sx={selectMenuItemStyle}>
                                                            {options.label}
                                                        </MenuItem>
                                                    ))}
                                                </RHFSelect>
                                            </Box>
                                        </Box>
                                    )}

                                    {/* Assignees */}
                                    {activeTime !== 'no-reminder' && activeTime !== '' && (
                                        <Box sx={{ mt: 1.5 }}>
                                            <AssignedToLead
                                                label="Assignees"
                                                assignToState={assignToStateNoBook}
                                                setAssignTo={setAssignToStateNoBook}
                                            />
                                        </Box>
                                    )}
                                    </Box>
                                </Box>

                                    {/* Notes */}
                                    {activeTime !== 'no-reminder' && activeTime !== '' && (
                                        <Box sx={{ mb: 2.5 }}>
                                            {SECTION_HEADER('eva:edit-2-fill', 'Notes', '3')}
                                            <Box sx={SECTION_CARD}>
                                            <RHFTextField name="OtherNotes" multiline rows={3} label="Additional notes" InputLabelProps={{ shrink: true }} placeholder='Add notes here' sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }} />
                                            </Box>
                                        </Box>
                                    )}
                            </>
                        ) : null
                    }
                </Box>
            </Box>
        </FormProvider>
    );
});

TreatmentAndAppointment.propTypes = {
    handleNext: PropTypes.func,
    type: PropTypes.string,
    isOverview: PropTypes.bool,
};

export default TreatmentAndAppointment;
